import React from 'react';
import ContactForm from '../components/ContactForm';
import SEOHeadNative from '../components/SEOHeadNative';

const Contact: React.FC = () => {
  return (
    <div>
      <SEOHeadNative
        title="Contact OZARKS ELEC - Électricien à Viesly"
        description="Contactez OZARKS ELEC pour vos projets électriques et de bâtiment à Viesly. Devis gratuit, intervention rapide dans l'Aisne et le Nord. Tel: 06 30 98 45 78"
        keywords="contact électricien, devis électricité, contact OZARKS ELEC, électricien Viesly contact, devis gratuit électricité"
        canonical="/contact"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ElectricalContractor",
          "name": "OZARKS ELEC",
          "url": "https://ozarkselec.com",
          "telephone": "+33630984578",
          "email": "ozarkselec@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "16 Rue de Prayelle",
            "addressLocality": "Viesly",
            "postalCode": "59271",
            "addressCountry": "FR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "50.068",
            "longitude": "3.427"
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "19:00"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+33630984578",
            "contactType": "customer service",
            "availableLanguage": "French"
          }
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Contact
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '30px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>📞 Informations de contact</h3>
                  <p className="ozarks-dark"><strong>Téléphone :</strong> +33 630 98 45 78</p>
                  <p className="ozarks-dark"><strong>Email :</strong> ozarkselec@gmail.com</p>
                  <p className="ozarks-dark"><strong>Adresse :</strong> 16 Rue de Prayelle, 59271 Viesly, France</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🕐 Horaires d'ouverture</h3>
                  <p className="ozarks-dark">Lundi - Vendredi : 8:00 - 19:00</p>
                  <p className="ozarks-gray" style={{fontSize: '14px', marginTop: '5px'}}>Interventions d'urgence possibles en dehors des horaires</p>
                </div>

                <div style={{marginBottom: '30px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🗺️ Zones d'intervention</h3>
                  <p className="ozarks-dark">Nous intervenons dans l'Aisne, la Thiérache, le Caudrésis/Catésis et toute la région Nord.</p>
                </div>

                <div>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>📱 Réseaux sociaux</h3>
                  <p>
                    <a 
                      href="https://www.facebook.com/profile.php?id=61555968326960" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="ozarks-blue-medium"
                      style={{textDecoration: 'none', fontWeight: 500}}
                    >
                      Suivez-nous sur Facebook →
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Formulaire de contact */}
      <div className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;